import { render } from "./SauSaget.vue?vue&type=template&id=6f0e6458"
const script = {}

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/SauSaget.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6f0e6458"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6f0e6458', __exports__)) {
    api.reload('6f0e6458', __exports__)
  }
  
  module.hot.accept("./SauSaget.vue?vue&type=template&id=6f0e6458", () => {
    api.rerender('6f0e6458', render)
  })

}


export default __exports__